import { gql } from "@apollo/client"
import {
  getDeparturePoints,
  getDeparturePointsVariables,
  getDeparturePoints_getDeparturePoints,
} from "./types/getDeparturePointsByDistrictId"

export const GET_DEPARTURE_POINTS_BY_DISTRICT_ID = gql`
  query getDeparturePointsByDistrict($districtId: ID!) {
    getDeparturePointsByDistrict(districtId: $districtId) {
      id
      name
      latitude
      longitude
      vehicleCount
      tourCount
    }
  }
`

export type GetDeparturePointsResult = getDeparturePoints
export type GetDeparturePointsVariables = getDeparturePointsVariables
export type DeparturePoint = getDeparturePoints_getDeparturePoints
